import qualify from '@/app/qualify/routes';
import file from '@/app/file/routes';
import { checkRouteForMainSections, getSections, isAuthenticatedAndNotAdmin } from '@/utils/nav-guards-checks';

const routes = [
  {
    path: '/:id?/main',
    name: 'main',
    component: () => import('@/app/main/pages/page-main'),
    beforeEnter: isAuthenticatedAndNotAdmin,
    redirect: { name: 'personal' },
    meta: {
      permission: 'any',
      fail: '/',
    },
    children: [
      {
        path: 'buy-coaching',
        name: 'buy-coaching',
        component: () => import('@/app/main/pages/main-buy-coaching'),
        beforeEnter: getSections,
      },
      {
        path: 'purchases',
        name: 'purchases',
        component: () => import('@/app/main/pages/main-purchases'),
        beforeEnter: getSections,
      },
      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/app/main/pages/main-payment'),
        beforeEnter: checkRouteForMainSections,
      },
      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/app/main/pages/main-personal'),
        beforeEnter: checkRouteForMainSections,
      },
      {
        path: 'assets',
        name: 'assets',
        component: () => import('@/app/main/pages/main-assets'),
        beforeEnter: checkRouteForMainSections,
      },
      {
        path: 'business',
        name: 'business',
        component: () => import('@/app/main/pages/main-business'),
        beforeEnter: checkRouteForMainSections,
      },
      {
        path: 'expenses',
        name: 'expenses',
        component: () => import('@/app/main/pages/main-expenses'),
        beforeEnter: checkRouteForMainSections,
      },
      {
        path: 'qualify',
        name: 'qualify',
        component: () => import('@/app/main/pages/main-qualify'),
        beforeEnter: checkRouteForMainSections,
        redirect: { name: 'qualify-main' },
        children: [
          ...qualify,
        ],
      },
      {
        path: 'file',
        name: 'file',
        component: () => import('@/app/main/pages/main-file'),
        redirect: { name: 'decision' },
        children: [
          ...file,
        ],
      },
    ],
  },
];

export default routes;
